import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { timeTrackingService } from '../api/time-tracking.service';
import { TIME_TRACKING_KEYS } from './queryKeys';
import type { TimeEntriesQueryParams } from '../types';

/** Paginated time entries for a project (reports). */
export function useProjectTimeEntries(projectId: string | null, params: TimeEntriesQueryParams) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  return useQuery({
    queryKey: TIME_TRACKING_KEYS.projectEntries(orgId ?? '', projectId ?? '', params),
    queryFn: ({ signal }) => timeTrackingService.getProjectTimeEntries(projectId!, params, signal),
    // Shared/collaborative data: always refetch on mount, filter change, and window focus
    staleTime: 0,
    refetchOnWindowFocus: true,
    enabled: !!orgId && !!projectId,
    placeholderData: keepPreviousData,
  });
}
